<ds-person-search-result-list-element [object]="{ indexableObject: object, hitHighlights: {} }"
                                      [linkType]="linkType"
                                      [showLabel]="showLabel"
                                      [value]="value"
>
</ds-person-search-result-list-element>
